import { create } from 'zustand';

export type WsStatus = 'idle' | 'connecting' | 'connected' | 'reconnecting' | 'offline';

interface RealtimeState {
  status: WsStatus;
  setStatus: (s: WsStatus) => void;
  /** Peer user ids we became connected with (connection.created) in this app run. */
  connectedPeers: Record<string, true>;
  markConnected: (userId: string) => void;
}

export const useRealtime = create<RealtimeState>((set) => ({
  status: 'idle',
  setStatus: (status) => set({ status }),
  connectedPeers: {},
  markConnected: (userId) => set((s) => ({ connectedPeers: { ...s.connectedPeers, [userId]: true } })),
}));
